import { Component, OnInit } from '@angular/core';
import { OurServiceService } from '../../services/our-service.service';
import { OurServiceModel } from '../../models/service.model';

@Component({
  selector: 'app-corporate-services',
  templateUrl: './corporate-services.component.html',
  styleUrls: ['./corporate-services.component.css']
})
export class CorporateServicesComponent implements OnInit{
// Set Topbar
currentLang = localStorage.getItem('lang') || 'ar';
  constructor(private ourService: OurServiceService) { }
ourservices:OurServiceModel[] = [];
  ngOnInit(): void {
    this.ourService.getAll().subscribe((res: any) => {
      this.ourservices = res;
      
    });
 
  }
  Menuoption = 'corporate'
  navClass = "nav-light";

/***
 * Header button list show
 */
  Settingicon = true;
  footerVariant = 'footer-five';
}
